import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "menuInlineSize", "variant"],
  _excluded2 = ["children", "disabled", "variant"],
  _excluded3 = ["children", "insetBlockStart", "paddingInlineEnd", "position"];
import { Dropdown as FoundationsDropdown } from 'foundations-components/transitional/components/Dropdown';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { Button } from '../Button';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { ButtonContent } from '../Button/ButtonContent';
import { IconContainer } from '../Icons/IconContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const Dropdown = _ref => {
  let {
      children,
      menuInlineSize,
      variant
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  return /*#__PURE__*/_jsx(FoundationsDropdown, Object.assign({}, rest, spacingProps, {
    buttonUse: variant,
    menuWidth: menuInlineSize,
    children: /*#__PURE__*/_jsx(List, {
      children: children
    })
  }));
};
const getVariantColor = (variant, disabled) => {
  if (disabled) return 'disabled';
  if (variant === 'danger') return variant;
  return 'base';
};
const Item = _ref2 => {
  let {
      children,
      disabled,
      variant
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(ListItem, {
    children: /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
      disabled: disabled,
      children: /*#__PURE__*/_jsx(ButtonContent, {
        color: getVariantColor(variant, disabled),
        children: children
      })
    }))
  });
};
Dropdown.Item = Item;
const DropdownItemIcon = props => /*#__PURE__*/_jsx(Button.Icon, Object.assign({}, props));
DropdownItemIcon.displayName = 'Dropdown.ItemIcon';
Dropdown.ItemIcon = DropdownItemIcon;
const DropdownIcon = _ref3 => {
  let {
      children,
      insetBlockStart = 'space-xxxs',
      paddingInlineEnd = 'space-xxs',
      position = 'relative'
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  return /*#__PURE__*/_jsx(IconContainer, Object.assign({}, rest, {
    insetBlockStart: insetBlockStart,
    paddingInlineEnd: paddingInlineEnd,
    position: position,
    children: children
  }));
};
DropdownIcon.displayName = 'Dropdown.Icon';
Dropdown.Icon = DropdownIcon;